import _ from "lodash";
import React from "react";

// Hooks
import { useI18n } from "Hooks";
import { connect } from "react-redux";

// Utils
import { getAvailableChatOptions } from "AppComponents/AITutorChatWrapper/modules/Utils";

// Modules
import { updateAIMessage } from "modules/Services";

// Components
import AIChat from "UIComponents/AIChat";
import ConfigureAIVoice from "AppComponents/ConfigureAIVoice";

// Constants
import { CREATE_DROPDOWN_OPTIONS } from "../../modules/Constants";
import { ASSESSMENT } from "Constants/stringConstants";

const iconButtonProps = {
  dsVersion: "2.0",
  size: "medium",
  variant: "neutral",
  type: "plain",
};

const AIChatFooter = props => {
  const {
    assessmentDetails,
    aiConversationId,
    onSendMessage,
    gradeId,
    messages,
  } = props;

  const { t } = useI18n();

  // ======== Variables ========
  const openingMessage = _.find(
    messages,
    ({ node }) => node?.metadata?.isOpeningMessage
  );

  const hasOpeningMsgAttachment =
    _.size(_.get(openingMessage, "node.attachments")) > 0;

  const availableChatOptions = getAvailableChatOptions(
    assessmentDetails,
    hasOpeningMsgAttachment
  );

  const customConfigureAIVoiceComp = () => {
    return (
      <>
        <ConfigureAIVoice
          customRef={null}
          gradeId={gradeId}
          entityType={ASSESSMENT}
          showLanguageDropdown={false}
          iconButtonProps={iconButtonProps}
          conversationId={aiConversationId}
          promptSetEntityType={"ai_tutor_chat"}
          headerSubtitle={t("classRoom:ai_voice_modal_subtext")}
        />

        <ConfigureAIVoice
          customRef={null}
          gradeId={gradeId}
          entityType={ASSESSMENT}
          showLanguageDropdown={false}
          iconButtonProps={iconButtonProps}
          conversationId={aiConversationId}
          promptSetEntityType={"ai_tutor_evaluation"}
          headerSubtitle={t("classRoom:ai_voice_modal_subtext")}
        />
      </>
    );
  };

  return (
    <AIChat.Footer
      {...props}
      audioVersion="visualiser"
      onSendMessage={onSendMessage}
      placeholder={t("common:typeHere")}
      footerOptions={availableChatOptions}
      customCreateDropdownOptions={CREATE_DROPDOWN_OPTIONS}
      customConfigureAIVoiceComp={customConfigureAIVoiceComp}
    />
  );
};

const mapActionCreators = { updateAIMessage };

export default connect(null, mapActionCreators)(AIChatFooter);
